import React, { ReactElement } from 'react';
import classnames from 'classnames';
import { Section } from '@fiverr-private/fit';

interface BannerWrapperProps {
    children: ReactElement;
}

export const BannerWrapper: React.FC<BannerWrapperProps> = ({ children }) => (
    <Section className={classnames('p-t-8', 'p-b-0')}>{children}</Section>
);
